export default __webpack_public_path__ + "static/request-demo-page-hero-514ad581c060c853dbdf105d57700ca5.png";